import React, { useEffect } from "react";

import { Select } from "antd";

import { connect } from "react-redux";

import {
  setPurposeOfTransfer,
  setPurposeOfTransferName,
  getAllowedPurposeOfTransfers,
  cleanup,
} from "rx/selectpurposeoftransfer";

function SelectPurposeOfTransferRxComponent(props) {
  useEffect(() => {
    props.getAllowedPurposeOfTransfers();
  }, []);

  return (
    <>
      <Select
        {...props}
        size="large"
        value={props.purposeOfTransferName}
        onChange={(purposeOfTransfer) => {
          props.setPurposeOfTransfer(purposeOfTransfer.split("|")[0]);
          props.setPurposeOfTransferName(purposeOfTransfer.split("|")[1]);
        }}
      >
        {props.allowedPurposeOfTransfers &&
          props.allowedPurposeOfTransfers.map((record) => {
            return (
              <Select.Option value={record.code + "|" + record.value} key="idx">
                {record.value}
              </Select.Option>
            );
          })}
      </Select>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    purposeOfTransfer: state.selectPurposeOfTransfer.purposeOfTransfer,
    purposeOfTransferName: state.selectPurposeOfTransfer.purposeOfTransferName,
    allowedPurposeOfTransfers:
      state.selectPurposeOfTransfer.allowedPurposeOfTransfers,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    cleanup: () => dispatch(cleanup()),
    setPurposeOfTransfer: (purposeOfTransfer) =>
      dispatch(setPurposeOfTransfer(purposeOfTransfer)),
    setPurposeOfTransferName: (purposeOfTransferName) =>
      dispatch(setPurposeOfTransferName(purposeOfTransferName)),
    getAllowedPurposeOfTransfers: () =>
      dispatch(getAllowedPurposeOfTransfers()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SelectPurposeOfTransferRxComponent);
